import { FileUploader, assert } from 'zf-infra';
import { UploadErrCode } from '../../types';
import { CommonError } from '../../error';
import { AliOSSUploader } from './alioss';
import { LightUploader } from './light';
import type { LocalStore } from '../../store';
import type { UploadParams } from 'zf-infra';

class Uploader extends FileUploader {

  private store?: LocalStore;
  private oss?: AliOSSUploader;

  init(store: LocalStore): void {
    this.store = store;
  }

  /**
   * 本地上传，上传到我们的后台服务器，用于Excel导入等场景
   */
  get local(): LightUploader {
    return new LightUploader();
  }

  /**
   * 默认的上传使用 ali oss
   * @param file
   * @param option
   * @returns
   */
  async upload(file: File | Blob, option?: UploadParams): Promise<string> {
    assert(this.store != null, 'local store cannot be empty');
    if (this.oss == null) {
      this.oss = new AliOSSUploader(this.store);
    }
    const videoSizeLimitEnable = option?.videoSizeLimitEnable ?? true;
    // 视频大小限制 默认 40M
    if (this.isVideo(file as File)
      && videoSizeLimitEnable === true
      && file.size > (option?.videoSizeLimit ?? 40) * 1024 * 1024) {
      throw new CommonError(`上传视频大小不能超过${option?.videoSizeLimit ?? 40}MB`, UploadErrCode.VIDEO_OVER_SIZE);
    }

    return await this.oss.upload(file, option);
  }

  async abort(fileKey: string, uploadId: string): Promise<void> {
    assert(this.store != null, 'local store cannot be empty');
    if (this.oss == null) {
      this.oss = new AliOSSUploader(this.store);
    }

    return await this.oss.abort(fileKey, uploadId);
  }

  /**
   * 上传的是否是视频
   * @param file
   * @returns
   */
  private isVideo(file: File): boolean {
    return file.type.includes('video');
  }

}

export const uploader = new Uploader();
